import { AgencesTab } from "./list";

export default function ParametresAgences() {
  return (
    <div className="p-6">
      <AgencesTab />
    </div>
  );
}